import { Component } from 'react';
import MonacoEditor from 'react-monaco-editor';
import { T, COMMON } from '../../common/js/i18n';

interface Props {
    onClose?: () => void;
}

interface State {
}


const demoProcessorCode = `
function (data)
    data.name = "omega"
    return data
end
`;

export default class ProcessorHelp extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }
    render() {
        let resizeListener: any = undefined;
        return (
            <div style={{ padding: "0.5em" }}>
                <p style={{ marginTop: "0.5em", marginBottom: "0.5em" }}>
                    {T({
                        en: "Please write a function in Lua language, one Lua object as input parameter, return a Lua object to render.",
                        zh: "请用lua语言编写一个函数，一个输入数据参数，返回一个输出数据。"
                    })}
                </p>
                {T({
                    en: "Demo pre-processor code",
                    zh: "Demo预处理器代码"
                })}:
                <MonacoEditor
                    width="100%"
                    height="8em"
                    language="lua"
                    theme="vs-dark"
                    value={demoProcessorCode}
                    options={{
                        selectOnLineNumbers: true,
                        readOnly: true
                    }}
                    onChange={(newVal: any, e: any) => {
                        this.setState({
                            value: newVal
                        });
                    }}
                    editorDidMount={(editor, monaco) => {
                        if (!resizeListener) {
                            resizeListener = () => {
                                editor.layout();
                            };
                            window.addEventListener("resize", resizeListener);
                        }
                    }}
                    editorWillUnmount={() => {
                        if (resizeListener) {
                            window.removeEventListener("resize", resizeListener);
                            resizeListener = undefined;
                        }
                    }}
                />
                <div style={{ textAlign: "center", paddingTop: '0.5em' }}>
                    <button type="button" className="btn" onClick={() => {
                        if (this.props.onClose) {
                            this.props.onClose();
                        }
                    }}>{T(COMMON.CLOSE)}</button>
                </div>
            </div>
        );
    }
}
